<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>职员管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'Account' }">职员列表</el-breadcrumb-item>
          <el-breadcrumb-item>新建职员</el-breadcrumb-item>
        </el-breadcrumb>
      
    <el-row style="padding: 30px">
      <el-col :span="12">
        <el-form
        size="mini"
          :model="customer"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
        >
          <el-form-item label="用户名" prop="username">
            <el-input v-model="customer.username" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="name">
            <el-input v-model="customer.name" maxlength="20"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="orgpassword">
            <el-input
              v-model="customer.orgpassword"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码确认" prop="password2">
            <el-input
              v-model="customer.password2"
              autocomplete="off"
              show-password
            ></el-input>
          </el-form-item>
            <el-form-item label="手机号" prop="mobile">
            <el-input v-model="customer.mobile" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="customer.email" maxlength="30"></el-input>
          </el-form-item>
          <el-form-item label="权限组" prop="roleid">
          <el-select v-model="customer.roleid" clearable placeholder="请选择">
    <el-option
      v-for="item in roles"
      :key="item.innerid"
      :label="item.name"
      :value="item.innerid">
    </el-option>
  </el-select>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="createUser()">创建</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../../assets/js/md5'
export default {
  name: 'CreateUser',
  data () {
    var usernameCheck = (tule, value, callback) => {
      if (value && value.indexOf('@') >= 0) {
        callback(new Error('用户名中不能包含@'))
      } else {
        callback()
      }
    }
    var mobileCheck = (tule, value, callback) => {
      if (value && (value.length != 11 || value[0] != 1)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var passwordCheck = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    var password2Check = (tule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else if (value !== this.customer.orgpassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }

    return {
      customer: {
        mobile: '',
        name:'',
        password: '',
        orgpassword: '',
        password2: '',
        username: '',
        roleid: '',
        email:''
      },
       roles:[],
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
          { validator: usernameCheck, trigger: 'blur' }],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        smscode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        orgpassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: passwordCheck, trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: password2Check, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    let customer = window.localStorage.getItem('customer')
    if (customer) {
          Vue.axios
          .post('/factory/role/all', {})
          .then((res) => {
            if (res.data.errcode == 0) {
              this.roles = res.data.msgbody
            }
          })
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    createUser () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          self.customer.password = hex_md5(self.customer.orgpassword)
          self.customer.orgpassword = ''
          self.customer.password2 = ''
          Vue.axios
            .post('/factory/user/add',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '帐号创建成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    },
    back () {
      this.$router.back()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/User/Add.vue